import { render, staticRenderFns } from "./TaskCountDown.vue?vue&type=template&id=a70ceb00&scoped=true"
import script from "./TaskCountDown.vue?vue&type=script&lang=js"
export * from "./TaskCountDown.vue?vue&type=script&lang=js"
import style0 from "./TaskCountDown.vue?vue&type=style&index=0&id=a70ceb00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70ceb00",
  null
  
)

export default component.exports